export const useLoading = () => ({
  rootProps: {
    role: "alert"
  }
});
